<template>
	<div>
		<div class="condition">
			<div class="search_wrap">
				<el-form :inline="true" :model="formdata" class="form-inline">
					<el-form-item label="用户信息">
						<el-input v-model="formdata.nickname" placeholder="微信昵称" class=" mr10" size="small"></el-input>
					</el-form-item>
					<el-form-item label="活动id">
						<el-input v-model="formdata.activity_id" placeholder="活动id" class=" mr10 w130" size="small"></el-input>
					</el-form-item>
					<el-form-item label="邀请人昵称">
						<el-input v-model="formdata.invite_name" placeholder="邀请人昵称" class="mr10" size="small"></el-input>
					</el-form-item>
					<el-form-item label="下单状态" >
						<el-select class="mr10 w130" v-model="formdata.status" size="small" placeholder="请选择下单状态">
							<el-option label="全部"  :value="0"></el-option>
							<el-option label="未下单" :value="1"></el-option>
							<el-option label="未支付" :value="2"></el-option>
							<el-option label="已购买" :value="3"></el-option>
						</el-select>              
					</el-form-item>
					<el-form-item label="创建时间">
						<el-date-picker
							v-model="timeData"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							size="small"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							:picker-options="pickerOptions1"
						></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary"  size="small" @click="searchcustomer">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="table_wrap">
			<el-table :data="tableData" style="width: 100%">
				<!-- <el-table-column prop="activity_id" label="活动id"></el-table-coluamn> -->
				<!-- <el-table-column prop="nickname" label="微信昵称"></el-table-column> -->
				<el-table-column label="微信" align="center">
					<template slot-scope="scope">
						<img :src="scope.row.avatar" alt width="60px" height="60px" v-if="scope.row.avatar"/>
						<img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
						<p>{{scope.row.nickname}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="title" label="活动名称">
					<div slot-scope="scope" >
						<span :title="scope.row.title ">{{scope.row.title | ellipsis}}</span>
					</div>
				</el-table-column> 
				<el-table-column prop="invitation_num" label="邀请人数"></el-table-column>
				<!-- <el-table-column prop="bogus_invitation_num" label="初始化邀请"></el-table-column>
				<el-table-column prop="bogus_commission" label="初始化佣金"></el-table-column> -->
				<el-table-column prop="commission" label="累计佣金"></el-table-column>
				<el-table-column   label="登记信息">
					<template slot-scope="scope" >
						<div v-for="(item,index) in scope.row.join_register_info" :key="index">
								<p>{{item.explain}}:{{item.value}}</p>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="邀请人" align="center">
					<template slot-scope="scope">
						<img :src="scope.row.invitation_avatar || 'static/img/userDefult.png'" alt width="60px" height="60px" style="display:block;margin:auto"/>
						<p style="text-align:center">{{scope.row.invitation_nickname}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="source_text" label="活动来源"></el-table-column>
				<el-table-column prop="pay_status_text" label="支付状态"></el-table-column>
				<el-table-column prop="create_time" label="参与时间" width="160">
					<div slot-scope="scope" >
						<span>{{scope.row.create_time.split(" ")[0]}}</span>
						<br>
						<span>{{scope.row.create_time.split(" ")[1]}}</span>
					</div>
				</el-table-column>
			</el-table>
			<div class="pag_wrap">
				<el-pagination
					background
					:page-size="page.page_size"
					:current-page="page.current_page"
					layout="total, prev, pager, next"
					:total="page.total_rows"
					@current-change="pageIndexChange"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import api from "@/api.js";
	import { pagination1 } from "@/util/util.js";
	export default {
		name: 'participationlog',
		filters: {//限制文本显示字数,超出部分用...代替
			ellipsis (value) {
					if (!value) return ''
					if (value.length > 10) {
						return value.slice(0,10) + '...'
					}
					return value
				}
		},
		data() {
		  return {
		    formdata: {
		      page: 1, // 	整型 	必填 	- 	- 	页码
					nickname: '', // 	整型 	必填 	- 	- 	用户信息
					invite_name:'',//邀请人昵称
		      start_time: '',
					end_time: '',
					activity_id: '',
					status: 0
		    },
		    tabIndex: 0,
		    timeData: [],
		    tableData: [],
				page: {
					current_page: pagination1.current_page,
					page_size: pagination1.page_size,
					total_rows: pagination1.total_rows
				},
		    pickerOptions1: {
		      disabledDate(time) {
		        return time.getTime() > Date.now(); //  - 8.64e7 减去就是不包含今天的
		      }
		    }
		  };
		},
		created() {
			this.formdata.activity_id = this.$route.query.id || "";
		  this.init();
		},
		methods: {
		  //初始化请求
		  init() {
		    this.querycustom();
		  },
		  // 查询
		  querycustom() {
		    if (this.timeData && this.timeData.length > 0) {
		      this.formdata.start_time = this.timeData[0]
		      this.formdata.end_time = this.timeData[1]
		    } else {
		      this.formdata.start_time = ""
		      this.formdata.end_time = ""
				}
				
		    this.axios
					.post(api.getJoinLog, this.formdata)
					.then(response => {
						console.log(response,"response162")
						if (response.data.code == 0) {
							// console.log('参与日志')
							// console.log(response)
							this.tableData = response.data.result;
							this.page = response.data.page;
						} 
					})
					.catch(response => {
					});
		  },
		  // 购买查询
		 //  querycustoms() {
			// if (this.timeData && this.timeData.length > 0) {
			//   this.formdata.start_time = this.timeData[0]
			//   this.formdata.end_time = this.timeData[1]
			// } else {
			//   this.formdata.start_time = ""
			//   this.formdata.end_time = ""
			// 		}
					// this.formdata.is_excel_out = 3
			// this.axios
			// 		.post(api.getBuyLog, this.formdata)
			// 		.then(response => {
						// console.log(response,"response185")
						// if (response.data.code == 0) {
						// 	this.skuList = response.data.result.sku_list
						// 	this.tableData = response.data.result.list;
						// 	this.page = response.data.page;
						// } 
			// 		})
			// 		.catch(() => {});
			// },
		  searchcustomer() {
		    this.formdata.page = 1;
		    this.querycustom();
		  },
		  pageIndexChange(pageindex) {
				this.formdata.page = pageindex;
		    this.querycustom();
		  }
		}
	}
</script>

<style scoped>
.condition .el-form-item{margin-bottom: 10px;}
</style>